export default "__VITE_PUBLIC_ASSET__db1c4e37__"